import React from "react";

const colWidth = "w-9";

const ScorecardRowSkeleton: React.FC = () => {
    return (
        <div className="flex flex-row flex-grow items-center justify-between mt-4 animate-pulse">
            <div className="uppercase min-w-[40px] h-4 bg-gray-200 rounded" style={{ width: 40, height: 16 }} />
            {Array.from({ length: 9 }).map((_, i) => (
                <div
                    key={`skel_score_fn_${i}`}
                    className={`flex flex-grow ${colWidth} h-6 rounded-full justify-center items-center`}
                >
                    <div className="bg-gray-200 rounded-full w-6 h-6" />
                </div>
            ))}
            <div className="flex h-6 mx-2 w-9 rounded-full justify-center items-center">
                <div className="bg-gray-200 rounded w-8 h-4" />
            </div>
            {Array.from({ length: 9 }).map((_, i) => (
                <div
                    key={`skel_score_bn_${i}`}
                    className={`flex flex-grow ${colWidth} h-6 rounded-full justify-center items-center`}
                >
                    <div className="bg-gray-200 rounded-full w-6 h-6" />
                </div>
            ))}
            <div className="flex h-6 w-9 mx-2 rounded-full justify-center items-center">
                <div className="bg-gray-200 rounded w-8 h-4" />
            </div>
            <div className="flex w-14 h-6 justify-center items-center">
                <div className="bg-gray-200 rounded w-10 h-4" />
            </div>
            <div className="flex w-14 h-6 justify-center items-center">
                <div className="bg-gray-200 rounded w-10 h-4" />
            </div>
        </div>
    );
};

export default ScorecardRowSkeleton; 